<template>
    <div class="h100p" v-loading="processing" element-loading-text="交卷中..." element-loading-spinner="el-icon-loading">
        <el-header>
            <h1><img :src="pageConfig.icon ? pageConfig.icon : require('../../assets/img/logo.png')" alt=""
                     style="width:38px;margin-top:-3px;"> {{ pageConfig.name }}</h1>
            <el-dropdown class="headerRight" trigger="click" @command="logout">
                <span class="el-dropdown-link"><img
                        src="https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png"/><span
                        style="cursor:pointer;color:#0070de">{{ info.examineeName }}</span></span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>{{ logoutTextConfig.name }}</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </el-header>
        <el-container>
            <el-main :style="status==1?'padding: 20px;background: #f7fbff;':''" v-loading="loading"
                     element-loading-text="加载中" element-loading-spinner="el-icon-loading">
                <div v-if="status==1" class="questionCon">
                    <div class="left">
                        <el-card class="box-card" shadow="hover" v-if="isHaveIntroduction()"
                                 style="margin-bottom: 18px">
                            <div>
                                <div style="font-size: 16px; font-weight: bold">竞赛说明</div>
                                <hr>
                                <div v-html="introduction" style="max-height: 300px; overflow-y: auto"></div>
                            </div>
                        </el-card>

                        <div v-for="(item,index) in question" :key="index+key">
                            <el-card class="box-card" :id="'module'+index" shadow="hover"
                                     v-if="item.question_list.length>0">
                                <div slot="header" class="unClearfix">
                                    <span>{{ item.name }}</span>
                                    <span>{{
                                        testPaperTextConfig.questionTypeTip.signMix(item.question_list.length, item.total_score)
                                        }}</span>
                                    <!-- <span v-if="item.type == 'choice' || item.type == 'uncertain_choice'" style="float:right">{{item.name}}漏选，得一半分值</span> -->
                                </div>
                                <div class="questionModle" :id="'module'+index+'question'+i"
                                     v-for="(e,i) in item.question_list" :key="i">
                                    <span>{{ i + 1 }}.</span>
                                    <p v-html="e.stem" class="ql-editor"></p>
                                    <div v-if="e.crosshead">
                                        <div v-for="(n,l) in e.crosshead" :key="l">
                                            <span class="questionIndex">（{{ l + 1 }}）</span>
                                            <p v-html="n.stem" class="ql-editor"
                                               style="display:inline-block;max-width:calc(100% - 45px)"></p>
                                        </div>
                                    </div>
                                    <p style="margin:10px 0">
                                        <el-tag v-if="e.attachment.stem" @click="questionStatus(index,i)" size="medium">
                                            <a :href="config_env.BASE_URL+getDownloadAddress(e.attachment.stem.file_path,e.attachment.stem.file_name)">
                                                <i class="el-icon-download"></i>
                                                {{ testPaperTextConfig.attachment }}
                                                {{ e.attachment.stem.file_name }}</a></el-tag>
                                    </p>
                                    <el-button v-hasPermi="['training:instance:add']"
                                               v-if="item.question_type == 'subjectivity' && e.training_id"
                                               @click="questionStatus(index,i),seeShare(e)" size="mini" type="primary"
                                               icon="el-icon-monitor" style="margin:10px 0 0">
                                        {{ e.training_label }}
                                    </el-button>
                                    <div v-if="item.question_type != 'fill' && item.question_type != 'subjectivity'">
                                        <el-radio-group v-model="e.answer[0]"
                                                        @change="questionStatus(index,i),pushAnswer(e)"
                                                        v-if="item.question_type == 'single_choice'">
                                            <el-radio v-for="(f,j) in e.choices" :key="j" :label="j"
                                                      style="display:block;"><i>{{ letter[j] }} .&nbsp;&nbsp;</i><span
                                                    v-html="f" class="ql-editor" style="display:inline-flex"></span>
                                            </el-radio>
                                        </el-radio-group>
                                        <el-radio-group v-model="e.answer[0]"
                                                        @change="questionStatus(index,i),pushAnswer(e)"
                                                        v-if="item.question_type == 'determine'" class="determine">
                                            <el-radio :label="1">{{ testPaperTextConfig.determine.right }}</el-radio>
                                            <el-radio :label="0">{{ testPaperTextConfig.determine.error }}</el-radio>
                                        </el-radio-group>
                                        <el-checkbox-group v-model="e.answer"
                                                           @change="checkboxChange(e.answer),questionStatus(index,i),pushAnswer(e)"
                                                           v-if="item.question_type == 'choice' || item.question_type == 'uncertain_choice'">
                                            <el-checkbox v-for="(f,j) in e.choices" :key="j" :label="j"
                                                         style="display:block;"><i>{{ letter[j] }}
                                                .&nbsp;&nbsp;</i><span v-html="f" class="ql-editor"
                                                                       style="display:inline-flex"></span></el-checkbox>
                                        </el-checkbox-group>
                                    </div>
                                    <div class="questAnswer" v-if="e.review_mode !== 'script'">
                                        <span class="questLabel" style="margin-top:9px;font-size:14px"
                                              v-if="item.question_type != 'subjectivity' || (e.submit_mode && (e.submit_mode.includes('text')||(e.submit_mode.length == 1 && e.submit_mode.includes('attachment'))))">{{
                                            testPaperTextConfig.answerLabel
                                            }}：</span>
                                        <div v-if="item.question_type === 'subjectivity'" class="subjectivity">
                                            <div v-if="e.submit_mode && e.submit_mode.includes('text')">
                                                <div v-if="e.crosshead.length>0">
                                                    <div v-for="(n,l) in e.crosshead" :key="l"
                                                         style="margin-bottom:10px !important">
                                                        <span class="questIndex">（{{ (l + 1) }}）&nbsp;</span>
                                                        <quill-editor :value.sync="e.answer[l]"
                                                                      @blur="pushAnswer"
                                                                      @focus="questionStatus(index,i)"
                                                                      :placeholder="testPaperTextConfig.crossheadAnswerTip.signMix(l + 1)"
                                                                      :data-questionId="e.id"
                                                                      :meta="{question: e, index: l}"
                                                                      style="display:inline-block;width:calc(100% - 48px)"></quill-editor>
                                                    </div>
                                                </div>
                                                <quill-editor v-else
                                                              @focus="questionStatus(index,i)"
                                                              @blur="pushAnswer"
                                                              :value.sync="e.answer[0]"
                                                              :placeholder="testPaperTextConfig.answerTip"
                                                              :data-questionId="e.id"
                                                              :meta="{question: e, index: 0}"
                                                              style="margin-bottom:10px !important"></quill-editor>
                                            </div>
                                        </div>
                                        <div v-if="item.question_type == 'subjectivity' && e.submit_mode && e.submit_mode.includes('link')"
                                             style="clear:both;">
                                            <span style="margin-top:13px;width: 80px;display: inline-block;">{{testPaperTextConfig.link}}：</span>
                                            <div class="subjectivity" style="margin-top:10px">
                                                <el-input v-model="e.link" @blur="pushAnswer(e)"
                                                          :placeholder="testPaperTextConfig.linkTip"></el-input>
                                            </div>
                                        </div>
                                        <div v-if="item.question_type == 'subjectivity' " class="subjectivity">
                                            <p v-if="e.submit_mode && e.submit_mode.includes('attachment')">
                                                <el-tag v-if="e.file" :closable="true" :disable-transitions="true"
                                                        @close="e.file=undefined" size="medium"
                                                        :style="e.submit_mode.length==1?'margin-top:6px;':'margin-top:6px;margin-left:80px'">
                                                    <a :href="config_env.BASE_URL+getDownloadAddress(e.file,e.fileName)">
                                                        <i class="el-icon-download"></i>
                                                        {{ e.fileName }}</a></el-tag>
                                                <el-button v-else
                                                           @click="questionIndex=[index,i],importDialogVisible=true,questionStatus(index,i)"
                                                           :key="key" size="mini" type="primary"
                                                           icon="el-icon-paperclip"
                                                           :style="e.submit_mode.length==1?'margin-top:6px;':'margin-top:6px;margin-left:80px'">
                                                    {{ testPaperTextConfig.uploadTip }}
                                                </el-button>
                                            </p>
                                        </div>
                                        <p v-else-if="item.question_type == 'fill'"
                                           style="display:inline-block;width:calc(100% - 80px);margin-top:-6px;">
                                            <el-input v-for="(an,a) in e.answer" @input="questionStatus(index,i)"
                                                      @focus="questionStatus(index,i)" @blur="pushAnswer(e)" :key="a"
                                                      v-model.trim="e.answer[a]" clearable
                                                      :placeholder="testPaperTextConfig.answerTip2.signMix(a + 1)"
                                                      style="margin:10px 10px 0 0;width:250px"></el-input>
                                        </p>
                                        <span v-else style="position:relative;top:8px;">
                                    {{
                                            item.question_type == 'single_choice' ? letter[e.answer] : (item.question_type == 'choice' || item.question_type == 'uncertain_choice' || item.question_type == 'determine' ? change(e.answer, item.question_type) : '')
                                            }}
                                </span>
                                    </div>
                                </div>
                            </el-card>
                        </div>
                    </div>
                    <div class="right">
                        <el-card class="box-card" shadow="hover">
                            <div slot="header" class="clearfix">
                                <span>{{ cardTextConfig.name }}</span>
                                <span>{{ cardTextConfig.answered }} {{ okNum }}/{{ questionNum }}</span>
                            </div>
                            <div class="questionButtons">
                                <div v-for="(item,index) in question" :key="index" v-show="item.question_list.length>0"
                                     style="margin-bottom:6px">
                                    <a :href="'#module'+index" @click="questionStatus(index,0)"
                                       style="padding-bottom:5px">{{ item.name }}</a>
                                    <div>
                                <span v-for="(e,i) in item.question_list" :key="i+key" class="questionButton">
                                    <a :href="'#module'+index+'question'+i"><el-button :type="e.type"
                                                                                       @click="questionStatus(index,i)"
                                                                                       style="width:100%">{{
                                        i + 1
                                        }}</el-button></a>
                                </span>
                                    </div>
                                </div>
                            </div>
                            <p style="line-height:46px;text-align:center"><span style="color:#c4c0cc">{{
                                examConfig.remainingTime
                                }}</span>&nbsp;&nbsp;{{ remainingTime }}</p>
                            <el-button class="el-button el-button--primary el-button--small"
                                       style="width:100%; -webkit-user-select: auto" :loading="processing"
                                       @click="handPaper">{{ cardTextConfig.button.commit.name }}
                            </el-button>
                        </el-card>
                    </div>
                </div>
                <user-exam-paper v-if="showPaperList"
                                 :examConfig="examConfig"
                                 :userExamPaperList="userExamPaperList"
                                 :examDurationUnitOptions="examDurationUnitOptions"
                                 @start="getAnswerSheet"></user-exam-paper>
                <div v-if="status!=1 && !showPaperList" class="main"
                     :style="examConfig.backgroundImg ? 'background: url(' + examConfig.backgroundImg + ')' : ''">
                    <div class="exam" v-if="status==0">
                        <template v-if="examConfig.showInfoConfirmation">
                            <h2>{{ info.exam.subject }}</h2>
                            <p>
                                {{
                                !notice ? infoConfirmTextConfig.tip.signMix(examConfig.stuKeyword) :
                                (infoConfirmTextConfig.tip2.signMix(examConfig.stuKeyword, examConfig.typeKeyword) +
                                (time ? infoConfirmTextConfig.tip3 : ''))
                                }}</p>
                            <div v-if="!notice" class="infoCon">
                                <el-row>
                                    <el-col :span="12"><span class="tit">{{
                                        examineeInfoTextConfig.examineeName.signMix(examConfig.stuKeyword)
                                        }}：</span><span
                                            style="color:#187de1;margin-right:200px">{{ info.examineeName }}</span>
                                    </el-col>
                                    <el-col :span="12"><span class="tit">{{
                                        examineeInfoTextConfig.admission
                                        }}：</span><span
                                            style="color:#187de1">{{ info.admissionNo }}</span></el-col>
                                </el-row>
                                <el-row><span class="tit">{{
                                    examineeInfoTextConfig.subject.signMix(examConfig.typeKeyword)
                                    }}：</span>{{ info.exam.subject }}
                                </el-row>
                                <el-row><span class="tit">{{
                                    examineeInfoTextConfig.assessmentSite
                                    }}：</span>{{ info.assessmentSite }}
                                </el-row>
                                <el-row>
                                    <el-col :span="12">
                                        <span class="tit" style="white-space:pre">{{
                                            examineeInfoTextConfig.centreName
                                            }}：</span>{{ info.centreName }}
                                    </el-col>
                                    <el-col :span="12">
                                        <span class="tit" style="white-space:pre">{{
                                            examineeInfoTextConfig.seatNo
                                            }}：</span>{{ info.seatNo }}
                                    </el-col>
                                </el-row>
                                <el-row><span class="tit">{{
                                    examineeInfoTextConfig.examTime.signMix(examConfig.typeKeyword)
                                    }}：</span>{{ info.exam.examTime }}
                                </el-row>
                                <el-row><span class="tit">{{
                                    examineeInfoTextConfig.examDuration.signMix(examConfig.typeKeyword)
                                    }}：</span>{{ info.exam.examDuration }}{{ unitLabel(info.exam.examDurationUnit) }}
                                </el-row>
                            </div>
                            <div v-else class="infoCon" v-html="ruleText"></div>
                            <p class="examButton">
                                <el-button class="primaryButton" v-if="!notice&&!time" type="primary" size="medium"
                                           :key="key" @click="infoConfirmation()">
                                    {{ infoConfirmTextConfig.button.confirm }}
                                </el-button>
                                <el-button class="primaryButton" v-else-if="notice&&time" type="primary" size="medium"
                                           :key="key">
                                    {{ infoConfirmTextConfig.button.countdown.signMix(examConfig.typeKeyword) }}：{{
                                    time
                                    }}
                                </el-button>
                                <el-button class="primaryButton" v-else type="primary" :key="key" size="medium"
                                           :loading="waiting"
                                           @click="startExam()">{{ examStr }}
                                </el-button>
                            </p>
                        </template>
                        <div v-else>
                            <img :src="require('@/assets/img/hourglass.gif')" alt="" width="80px" height="80px"
                                 style="margin: 2px 0 10px">
                            <p class="examTip" style="font-size: 46px;height: 60px">
                                {{
                                time !== null ? time :
                                infoConfirmTextConfig.button.started.signMix(examConfig.typeKeyword)
                                }}</p>
                            <p class="examButton" style="margin-top: 50px">
                                <el-button class="primaryButton" v-if="time !== null" type="primary" size="medium"
                                           :key="key" disabled>
                                    {{ infoConfirmTextConfig.button.noStart.signMix(examConfig.typeKeyword) }}
                                </el-button>
                                <el-button class="primaryButton" v-else type="primary" :key="key" size="medium"
                                           :loading="waiting"
                                           @click="startExam()">
                                    {{ infoConfirmTextConfig.button.start.signMix(examConfig.typeKeyword) }}
                                </el-button>
                            </p>
                        </div>
                    </div>
                    <div v-else-if="status==3" class="exam">
                        <i class="el-icon-warning" style="font-size:70px;color:#E6A23C"></i>
                        <p class="examTip" style="color:#E6A23C">{{ errorStr }}</p>
                        <el-button type="primary" v-if="isDisplayScore" @click="goResult" style="margin-top: 30px">{{
                            cardTextConfig.button.commit.displayScore }}
                        </el-button>
                    </div>
                    <div v-else-if="status==2" class="exam">
                        <i class="el-icon-success" style="font-size:70px;color:#0070de"></i>
                        <p class="examTip">{{ cardTextConfig.button.commit.success.message }}</p>

                        <el-button v-if="info.exam.examCategory === 'train'" type="primary" @click="resumeExam">{{
                            examStr }}
                        </el-button>
                        <el-button type="primary" v-if="isDisplayScore" @click="goResult" style="margin-top: 30px">{{
                            cardTextConfig.button.commit.displayScore }}
                        </el-button>
                        <p v-else-if="info.exam.examCategory !== 'train' && examConfig.endTip">{{
                            cardTextConfig.button.commit.success.tip.signMix(examConfig.stuKeyword) }}</p>
                    </div>
                </div>
                <waves-svg v-if="examConfig.backgroundWaves && status!=1"></waves-svg>
                <p v-if="status!=1" class="footer" style="white-space: pre">{{ copyRightConfig }}</p>
            </el-main>
        </el-container>
        <file-upload :show.sync="importDialogVisible" @close="close"></file-upload>

        <el-dialog
                :title="connectErrorTextConfig.title"
                :visible.sync="connectErrorDialogVisible"
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                :show-close="false"
                class="connect-error-dialog"
                width="400px"
                center>
            <p><i class="el-icon-warning"></i>{{ connectErrorTextConfig.tip1 }}</p>
            <p>{{ connectErrorTextConfig.tip2 }}</p>

            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="reload">{{ connectErrorTextConfig.reload }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import wavesSvg from '@/components/waves'
    import quillEditor from '@/components/editor/index.vue'
    import fileUpload from '../../components/fileUpload/index.vue'
    import userExamPaper from "@/views/candidate/components/userExamPaper.vue";
    import {getDownloadAddress, getRandomNum, judgePermissions, parseTime} from '@/utils/common.js'
    import Cookies from 'js-cookie'
    import SocketIO from 'socket.io-client'
    import {getDict} from "@/api/dict";
    import moment from 'moment'
    import {getUserExamPaper} from "@/api/arrangement";
    import {commitFinalAnswer, getAnswerSheet, getCurrentAnswer} from "@/api/exam";

    export default {
        name: '',
        components: {
            wavesSvg, quillEditor, fileUpload, userExamPaper
        },
        data() {
            return {
                baseUrl: process.env.NODE_ENV === 'development' ? '' : Cookies.get('APP_BASE_API'),
                pageConfig: {
                    name: '',                      // 名称，原：1+X证书考试系统
                    icon: '',                      // 图标（为空则按照原设计）
                },
                examConfig: {
                    typeKeyword: '',                // 替换所有考试关键字，原：考试
                    stuKeyword: '',                 // 替换所有考生关键字，原：考生
                    backgroundImg: '',              // 考生确认页、考生等待页、实训环境加载页的背景图（为空则按照原设计）
                    backgroundWaves: false,         // 考生确认页、考生等待页、实训环境加载页的背景波浪是否显示
                    showInfoConfirmation: false,    // true：显示考生信息确认页；false：不显示考生信息确认页，提前登录则进入等待页面
                    remainingTime: '',              // 剩余时间名称，原：考试剩余时间
                    endTip: false,                  // 是否显示考试结束提示语，原：true
                },
                notice: false,
                info: {
                    examineeName: '',
                    exam: {subject: ''}
                },
                startTime: null,
                endTime: null,
                time: '',
                timer: null,
                key: 0,
                status: null,
                questionNum: 0,
                questionScore: 0,
                letter: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
                question: [],
                okNum: 0,
                remainingTime: null,
                remainingTimer: null,
                loading: true,
                importDialogVisible: false,
                questionIndex: [0, 0],
                errorStr: '',
                hasPaper: true,
                examStr: '',
                answer: [],
                userName: null,
                sendAnswerLock: false,
                socket: null, // Socket.IO 客户端实例
                connectErrorDialogVisible: false,
                answerQueueKey: "",
                examDurationUnitOptions: [],
                showPaperList: false,
                userExamPaperList: [],
                answerSheet: null,
                timeDifference: 0,  // 本地时间与服务器时间差（单位毫秒）
                introduction: '',
                waiting: false,
                isDisplayScore: false,
                processing: false,
            }
        },
        computed: {
            isConfirmInfo() {
                return this.$store.state.global.isConfirmInfo
            },
            showQuestionScore() {
                return this.$store.state.global.textConfig.showQuestionScore
            },
            copyRightConfig() {
                return this.$store.state.global.textConfig.copyRight
            },
            logoutTextConfig() {
                return this.$store.state.global.textConfig.logout
            },
            candidateTextConfig() {
                return this.$store.state.global.textConfig.frontend.candidate
            },
            testPaperTextConfig() {
                return this.candidateTextConfig.testPaper
            },
            cardTextConfig() {
                return this.candidateTextConfig.card
            },
            connectErrorTextConfig() {
                return this.candidateTextConfig.connectError
            },
            infoConfirmTextConfig() {
                return this.candidateTextConfig.infoConfirm
            },
            examineeInfoTextConfig() {
                return this.infoConfirmTextConfig.examineeInfo
            },
            ruleText() {
                return this.infoConfirmTextConfig.ruleText.signMix(this.examConfig.typeKeyword, this.examConfig.stuKeyword,
                    this.examConfig.typeKeyword, this.examConfig.stuKeyword, this.examConfig.typeKeyword,
                    this.examConfig.stuKeyword, this.examConfig.typeKeyword, this.examConfig.stuKeyword,
                    this.examConfig.typeKeyword, this.examConfig.stuKeyword, this.examConfig.stuKeyword,
                    this.examConfig.stuKeyword, this.examConfig.stuKeyword, this.examConfig.stuKeyword)
            },
        },
        created() {
            getDict('exam_duration_unit').then(res => {
                this.examDurationUnitOptions = res.data
            })
            let token = Cookies.get("TipDM-Login-Token");

            this.socket = SocketIO(this.baseUrl, {
                query: {
                    "randKey": this.getRandomNum(6),
                    "token": token
                },
                transports: ['websocket']
            });

            this.socket.on('connect', () => {
                this.init()
            })
        },
        methods: {
            pushAnswer(question, index, content) {

                if (!this.socket.connected) {
                    this.connectErrorDialogVisible = true
                    return
                }

                let subQuestions = -1
                let answer;
                if(index) {
                    if (question.crosshead && question.crosshead.length > 0) {
                        subQuestions = question.crosshead.length
                        answer = content
                    } else {
                        answer = [content]
                    }
                } else {
                    answer = question.answer
                }

                const payload = {
                    questionId: question.id,
                    answer: answer,
                    file: question.file,
                    fileName: question.fileName,
                    identity: new Date().getTime(),
                    link: question.link,
                    index: index,
                    subQuestionCount: subQuestions
                }

                this.socket.timeout(5000).emit('commit_answer', JSON.stringify(payload), (err, res) => {
                    if(err) {
                        console.error(err)
                    }

                    if(res) {
                        console.log(res)
                    }
                });
            },
            isHaveIntroduction() {
                if (this.introduction) {
                    return this.introduction.replace(/<\/?[^>]+(>|$)/g, "")
                } else {
                    return false
                }
            },
            init() {
                // 删除已交卷标识，如果存在
                Cookies.remove('submitted')
                let config = this.$store.state.projectConfig
                this.pageConfig = config.page
                this.examConfig = config.examModule
                this.errorStr = this.candidateTextConfig.noInfoMessage.signMix(this.examConfig.typeKeyword)
                this.examStr = this.candidateTextConfig.startMessage.signMix(this.examConfig.typeKeyword)

                this.$store.dispatch("getExamCurrent").then(res => {
                    if (res.status == 200) {
                        if (res.errorCode === 20001 || res.errorCode === 20007 || res.errorCode === 20008 || res.errorCode === 20010) {
                            this.showPaperList = false
                            this.status = 3
                            this.errorStr = res.message || this.candidateTextConfig.noInfoMessage.signMix(this.examConfig.typeKeyword)

                            if (res.errorCode === 20010) {
                                getUserExamPaper().then(paper => {
                                    this.isDisplayScore = true
                                    this.userExamPaperList = paper.data.map(function (item) {
                                        item.timeDifference = new Date(item.currentTime).getTime() - new Date().getTime();
                                        return item;
                                    })
                                    if (!this.info.examineeName) {
                                        this.$store.dispatch("getExamCurrentName").then(data => {
                                            this.info.examineeName = data.data;
                                        });
                                    }
                                })
                            } else {
                                setTimeout(() => {
                                    this.logout()
                                }, 3000)
                            }
                        } else {
                            this.timeDifference = new Date(res.data.currentTime).getTime() - new Date().getTime()
                            this.info = res.data
                            // 获取考试试卷列表
                            getUserExamPaper().then(paper => {
                                this.userExamPaperList = paper.data.map(function (item) {
                                    item.timeDifference = new Date(item.currentTime).getTime() - new Date().getTime();
                                    return item;
                                })
                            })


                            this.userName = localStorage.getItem("1+XAdministration")
                            let examAgainPaperId = localStorage.getItem('examAgain')
                            if (examAgainPaperId) {
                                this.getAnswerSheet(examAgainPaperId)
                                localStorage.removeItem('examAgain')
                            } else {
                                this.info.exam.examTime = moment(this.info.exam.startTime).format("YYYY年MM月DD日 HH:mm") + ' - ' + moment(this.info.exam.endTime).format("YYYY年MM月DD日 HH:mm")
                                this.status = 0

                                if (this.isConfirmInfo && this.info.exam.examCategory === 'train') {
                                    this.showPaperList = true
                                } else if (!this.isConfirmInfo) {
                                    if (!this.examConfig.showInfoConfirmation) {
                                        this.infoConfirmation()
                                    }
                                }
                            }
                        }
                    }
                    this.loading = false
                })
            },
            resumeExam() {
                // 获取考试试卷列表
                getUserExamPaper().then(paper => {
                    this.userExamPaperList = paper.data.map(function (item) {
                        item.timeDifference = new Date(item.currentTime).getTime() - new Date().getTime();
                        return item;
                    })
                    this.showPaperList = true
                })
            },
            getDownloadAddress,
            logout() {
                sessionStorage.clear()
                localStorage.removeItem('1+XUserIdentity')
                localStorage.removeItem('1+XPermissionsList')
                window.location.href = '/logout'
            },
            close(data) {
                this.importDialogVisible = false
                let index = this.questionIndex[0], i = this.questionIndex[1]
                this.question[index].question_list[i].file = data.file_path
                this.question[index].question_list[i].fileName = data.file_name
                this.pushAnswer(this.question[index].question_list[i])
            },
            infoConfirmation() {
                this.notice = true

                this.countDown()
                this.timer = setInterval(this.countDown, 1000);
            },
            startExam() {
                if (this.info.exam.examCategory === 'train') {
                    this.$store.state.global.isConfirmInfo = true
                    this.showPaperList = true
                    return
                }
                this.getAnswerSheet(this.info.exam.examPaperList[0].examPaperId)
            },
            goResult() {
                let param = {
                    examPaperId: this.userExamPaperList[0].examPaperId,
                    answerSheetId: this.userExamPaperList[0].answerSheetId,
                    examCategory: this.userExamPaperList[0].examCategory,
                    examIsDisplayScore: this.userExamPaperList[0].examIsDisplayScore,
                    examIsDisplayAnswer: this.userExamPaperList[0].examIsDisplayAnswer,
                    examEndTime: this.userExamPaperList[0].examEndTime,
                    timeDifference: this.userExamPaperList[0].timeDifference,
                    isExaminee: true,
                    showQuestionScore: true
                }
                localStorage.setItem('setExamineePaperInfo', JSON.stringify(param))
                this.$router.push('/reviewDetails')
            },
            getAnswerSheet(examPaperId) {
                this.waiting = true
                getAnswerSheet(examPaperId).then(res1 => {
                    this.waiting = false
                    if (res1.status === 200) {
                        if (res1.errorCode === 20001 || res1.errorCode === 20007 || res1.errorCode === 20008 || res1.errorCode === 20010) {
                            this.showPaperList = false
                            this.status = 3
                            this.errorStr = res1.message || this.candidateTextConfig.noInfoMessage.signMix(this.examConfig.typeKeyword)

                            if (res1.errorCode === 20010) {
                                getUserExamPaper().then(paper => {
                                    this.isDisplayScore = true
                                    this.userExamPaperList = paper.data.map(function (item) {
                                        item.timeDifference = new Date(item.currentTime).getTime() - new Date().getTime();
                                        return item;
                                    })
                                })
                            } else {
                                setTimeout(() => {
                                    this.logout()
                                }, 3000)
                            }
                        } else {
                            this.status = 1
                            getCurrentAnswer().then(res => {
                                this.answerSheet = res.data
                                let alreadyAnswer = res.data.questionAnswerList
                                if (alreadyAnswer.length > 0) {
                                    this.examStr = this.infoConfirmTextConfig.button.continue.signMix(this.examConfig.typeKeyword)
                                }

                                this.answer = alreadyAnswer
                                this.showPaperList = false
                                this.remainingTimer = setInterval(this.examCountDown, 1000)
                                this.getPaper()
                            })
                        }
                    }
                }).catch(() => {
                    this.waiting = false
                })
            },
            countDown() {
                let nowTime = this.getNowDate()
                let endTime = new Date(this.info.exam.startTime)
                let second = parseInt((endTime.getTime() - nowTime.getTime()) / 1000)
                this.time = this.secondFormatter(second)
                if (second <= 0) {
                    this.time = null;
                    clearInterval(this.timer)
                }
            },
            examCountDown() {
                let second1 = this.getSecondByEndTime()
                let second2 = this.getSecondByDuration()
                let second = second1 < second2 ? second1 : second2
                if (second === 300) {
                    this.$message({
                        type: 'Warning',
                        message: this.cardTextConfig.button.commit.autoTip.signMix(this.examConfig.typeKeyword)
                    });
                } else if (second === 10) {
                    this.$message({
                        type: 'Warning',
                        message: this.cardTextConfig.button.commit.autoTip2
                    });
                }
                this.remainingTime = this.secondFormatter(second)
                if (second <= 0) {
                    this.remainingTime = null
                    this.examConfig.endTip = true
                    this.endExam()
                }
            },
            getSecondByEndTime() {
                let nowTime = this.getNowDate().getTime()
                let endTime = new Date(this.info.exam.endTime).getTime()
                return parseInt((endTime - nowTime) / 1000)
            },
            getSecondByDuration() {
                let startTime = new Date(this.answerSheet.createdAt * 1000).getTime()
                let endTime = this.getNowDate().getTime()
                return parseInt((this.durationToSecondMill() - (endTime - startTime)) / 1000)
            },
            durationToSecondMill() {
                let secondMill = 0
                let unit = this.info.exam.examDurationUnit
                let examDuration = this.info.exam.examDuration
                if (unit === 'day') {
                    secondMill = examDuration * 24 * 60 * 60000
                } else if (unit === 'hour') {
                    secondMill = examDuration * 60 * 60000
                } else {
                    secondMill = examDuration * 60000
                }
                return secondMill
            },
            secondFormatter(second) {
                function addZero(i) {
                    return i < 10 ? "0" + i : i + ""
                }

                let d = parseInt(second / (24 * 60 * 60))
                let h = parseInt(second / (60 * 60) % 24)
                let m = parseInt(second / 60 % 60)
                let s = parseInt(second % 60)
                m = addZero(m)
                s = addZero(s)
                return `${d != '0' ? d + ' 天 ' : ''}${h != '0' ? h + ' 时 ' : ''}${m != '00' ? m + ' 分 ' : ''}${s} 秒`
            },
            change(answer, type) {
                if (type == 'choice' || type == 'uncertain_choice') {
                    // answer.sort();
                    let arr = []
                    for (let i = 0; i < answer.length; i++) {
                        const j = answer[i]
                        arr.push(this.letter[j])
                    }
                    return arr.join('、')
                } else if (type == 'determine') {
                    if (answer[0] === 0) {
                        return this.testPaperTextConfig.determine.error
                    } else if (answer[0] === 1) {
                        return this.testPaperTextConfig.determine.right
                    } else {
                        return ''
                    }
                }
            },
            checkboxChange(val) {
                return val.sort()
            },
            questionStatus(index, n) {
                let num = 0
                for (let i = 0; i < this.question.length; i++) {
                    const list = this.question[i].question_list;
                    for (let j = 0; j < list.length; j++) {
                        const e = list[j];
                        let isOk = true
                        if (e.answer.length > 0) {
                            for (let k = 0; k < e.answer.length; k++) {
                                const f = e.answer[k]
                                if (e.file) {
                                    if (f === '' && e.file == false) isOk = false
                                } else {
                                    if (f === '') isOk = false
                                }
                                if (e.link) {
                                    isOk = true
                                }
                            }
                        } else {
                            isOk = false
                        }

                        if (isOk) {
                            num += 1
                            e.type = 'success'
                        } else {
                            e.type = ''
                        }
                    }
                }
                this.okNum = num
                if (index === 0 || index > 0) {
                    this.question[index].question_list[n].type = 'primary'
                }
            },
            getPaper() {
                let answer = this.answer
                this.loading = true
                this.$store.dispatch("getExamPaper").then(res => {
                    let question = res.data.confirmed_paper
                    this.introduction = res.data.introduction
                    this.questionScore = res.data.total_score
                    this.questionNum = res.data.question_num
                    for (let i = 0; i < question.length; i++) {
                        const q = question[i];
                        const list = question[i].question_list;
                        for (let j = 0; j < list.length; j++) {
                            const e = list[j];
                            if (!e.attachment) {
                                e.attachment = {}
                            }

                            let scoreDiv = this.showQuestionScore ? `<span class="el-tag el-tag--info el-tag--mini scoreTag">${e.score}分</span>` : ''
                            let stem = e.stem
                            if (stem.indexOf('</p>') != -1) {
                                e.stem = stem.slice(0, -4) + `${scoreDiv}</p>`
                            } else {
                                e.stem = stem + scoreDiv
                            }
                            if (q.question_type == 'single_choice') {
                                e.answer = []
                            } else if (q.question_type == 'choice' || q.question_type == 'uncertain_choice') {
                                e.answer = []
                            } else if (q.question_type == 'determine') {
                                e.choices = [this.testPaperTextConfig.determine.right, this.testPaperTextConfig.determine.error]
                                e.answer = []
                            } else if (q.question_type == 'fill') {
                                let arr = e.stem.split('[[]]')
                                e.answer = []
                                for (let l = 0; l < arr.length - 1; l++) {
                                    let str = '______(' + (l + 1) + ')______'
                                    e.stem = e.stem.replace(/\[\[\]\]/, str)
                                    e.answer.push('')
                                }
                            } else if (q.question_type == 'subjectivity') {
                                e.answer = ['']
                                if (e.crosshead) {
                                    for (let l = 0; l < e.crosshead.length; l++) {
                                        if (l > 0) {
                                            e.answer.push('')
                                        }
                                        const f = e.crosshead[l]
                                        let str = f.stem
                                        let scoreDiv = this.showQuestionScore ? `<span class="el-tag el-tag--info el-tag--mini scoreTag">${f.score}分</span>` : ''
                                        if (str.indexOf('</p>') != -1) {
                                            f.stem = str.slice(0, -4) + `${scoreDiv}</p>`
                                        } else {
                                            f.stem = str + scoreDiv
                                        }
                                    }
                                } else {
                                    e.crosshead = []
                                }
                            }
                            if (answer.length) {
                                let an = answer.find(val => {
                                    return val.questionId == e.id
                                })
                                if (an) {
                                    e.answer = an.answer
                                    e.link = an.link
                                    if (an.file) {
                                        e.file = an.file
                                        e.fileName = an.fileName
                                    }
                                    let isOk = true
                                    if (e.answer.length > 0) {
                                        for (let k = 0; k < e.answer.length; k++) {
                                            const f = e.answer[k];
                                            if (f === '') isOk = false
                                        }
                                    } else {
                                        isOk = false
                                    }
                                    if (isOk) {
                                        e.type = 'success'
                                    } else {
                                        e.type = ''
                                    }
                                }
                            }
                        }
                    }
                    this.question = question
                    this.questionStatus()
                    this.loading = false
                })
            },
            handPaper() {
                let textConfig = this.cardTextConfig.button.commit
                let str = this.okNum == this.questionNum ? textConfig.message : textConfig.message2
                this.$confirm(str, textConfig.title, {
                    confirmButtonText: textConfig.ok,
                    cancelButtonText: textConfig.cancel,
                    type: 'warning',
                    center: true,
                    customClass: 'handPaper'
                }).then(() => {
                    this.endExam()
                })
            },
            async endExam() {
                this.processing = true
                // 将交卷标识写入Cookie
                Cookies.set('submitted', true)
                commitFinalAnswer().then(() => {
                    this.processing = false
                    this.status = 2
                    this.$store.dispatch("stopAllTrainingInstance")
                    clearInterval(this.remainingTimer)
                    this.question = []

                    setTimeout(() => {
                        this.$store.dispatch("getExamCurrent").then(res => {
                            if (res.errorCode === 20001 || res.errorCode === 20007 || res.errorCode === 20008 || res.errorCode === 20010) {
                                this.showPaperList = false

                                if (this.info.exam.isDisplayScore && res.errorCode === 20010) {
                                    getUserExamPaper().then(paper => {
                                        this.isDisplayScore = true
                                        this.userExamPaperList = paper.data.map(function (item) {
                                            item.timeDifference = new Date(item.currentTime).getTime() - new Date().getTime();
                                            return item;
                                        })
                                    })
                                } else {
                                    setTimeout(() => {
                                        this.logout()
                                    }, 1000)
                                }
                            }
                        })
                    }, 3000)
                }).catch(err => {
                    this.processing = false
                    if (err.response.data.message.indexOf('已结束') > -1) {
                        this.status = 3
                        this.errorStr = err.response.data.message
                        setTimeout(() => {
                            this.logout()
                        }, 3000)
                    }
                })
            },
            seeShare(e) {
                this.$store.dispatch("getTrainingInstanceSrc", e.training_id).then(res => {
                    if (res.status == 200) {
                        let routeUrl = this.$router.resolve({
                            path: "/practicalTraining",
                            query: {
                                name: this.userName,
                                exam: true,
                                trainingMirror: e.training_id,
                                examPaperId: this.answerSheet.examPaperId,
                                examPaperQuestionId: e.id,
                                reviewMode: e.review_mode
                            }
                        });
                        window.open(routeUrl.href, 'practicalTraining_blank');
                    }
                })
            },
            debounce(fn, wait) {
                if (this.status == 1) {
                    var timer = null;
                    return function () {
                        if (timer !== null) {
                            clearTimeout(timer);
                        }
                        timer = setTimeout(fn, wait);
                    }
                }
            },
            unitLabel(type) {
                let already = this.examDurationUnitOptions.find(item => item.dict_value == type)
                return already ? already.dict_label : ''
            },
            reload() {
                location.reload()
            },
            getNowDate() {
                return new Date(new Date().getTime() + this.timeDifference)
            }
        }
    }
</script>

<style scoped>
    .el-header {
        color: #0070de;
        line-height: 60px;
        display: flex;
        justify-content: space-between;
        padding: 0 20px;
        font-size: 15px;
    }

    .el-header h1 {
        font-weight: 600;
        font-size: 20px;
    }

    .headerRight img {
        height: 40px;
        width: 40px;
        object-fit: cover;
        border-radius: 50%;
        margin-right: 12px;
    }

    .el-container {
        height: calc(100% - 60px);
        overflow: auto;
    }

    .el-aside {
        color: #333;
    }

    .el-menu-item.is-active {
        background-color: rgb(21, 31, 44) !important;
    }

    .el-main {
        padding: 0;
        min-height: 600px;
    }

    .main {
        height: calc(100% - 40px);
        color: #333;
        width: 100%;
        background: linear-gradient(to bottom, #b2d8ff 0%, #fff 100%);
        background-size: 100% 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .footer {
        background: #0070de;
        color: #fff;
        line-height: 40px;
        text-align: center;
        font-size: 12px;
        width: 100%;
    }

    .bg2 {
        height: 336px;
        background: url("../../assets/img/bg-2.png") no-repeat;
        background-size: cover;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
    }

    .exam {
        width: 838px;
        padding: 40px;
        border-radius: 15px;
        background: #fff;
        position: relative;
        z-index: 1;
        text-align: center;
    }

    .exam > p {
        font-weight: 600;
        margin: 22px 60px 10px;
        text-align: center;
        color: #cc0000;
    }

    .exam h2 {
        text-align: center;
        font-weight: 600;
        font-size: 22px;
        color: #0070de;
    }

    .exam .el-row {
        line-height: 48px;
        font-weight: 600;
        font-size: 14px;
    }

    .exam .infoCon {
        background: #f1f8ff;
        padding: 24px 40px 40px;
        border-radius: 15px;
        text-align: left;
    }

    .exam .examButton {
        text-align: center;
        margin: 0;
        height: 20px;
    }

    .exam .examTip {
        font-size: 26px;
        font-weight: 600;
        color: #0070de;
    }

    .primaryButton {
        min-width: 200px;
        padding: 12px 20px;
        position: relative;
        top: -21px;
    }

    .questionCon {
        height: 100%;
    }

    .questionCon .right {
        width: 300px;
        min-width: 300px;
    }

    .questionCon .right .box-card {
        height: calc(100% - 2px);
        margin-bottom: 0;
    }

    .questionCon .el-card__header .clearfix span, .questionCon .el-card__header .unClearfix span {
        font-size: 14px;
        display: inline-block;
        padding-top: 4px;
        margin-left: 20px;
    }

    .questionCon .el-card__header .clearfix span:first-child, .questionCon .el-card__header .unClearfix span:first-child {
        font-weight: 600;
        margin-left: 0;
        font-size: 16px;
    }

    .questionCon .el-card__header .clearfix span:last-child {
        float: right;
        margin-left: 0;
    }

    .questionCon .right .box-card .questionButtons {
        height: calc(100% - 124px);
        width: 100%;
        overflow-y: auto;
    }

    .questionCon .right .box-card .questionButton {
        margin: 5px 10px 5px 0;
        width: 16.7%;
        display: inline-block;
        box-sizing: border-box;
    }

    .questionCon .right .box-card .questionButton:nth-child(5n) {
        margin-right: 0;
    }

    .questionCon .right .box-card .questionButton .el-button {
        padding: 9px 0;
    }

    .questAnswer {
        padding-top: 10px;
        min-height: 26px;
    }

    .questLabel {
        display: inline-block;
        float: left;
        width: 80px
    }

    .questAnswer .subjectivity {
        display: inline-block;
        width: calc(100% - 80px);
    }

    .questAnswer .subjectivity .questIndex {
        display: inline-block;
        line-height: 40px;
        float: left;
        font-size: 14px;
        width: 48px;
    }

    .questionModle {
        padding: 20px 20px 30px 45px;
        position: relative;
        margin-bottom: 10px;
        border: 1px solid #fff;
    }

    .questionModle:hover {
        border-color: #ebeef5;
        border-radius: 4px;
    }

    .questionModle > span {
        font-weight: 600;
        position: absolute;
        top: 25px;
        left: 18px;
    }

    .questionModle >>> .scoreTag {
        font-size: 13px !important;
        margin-left: 10px;
    }

    .questAnswer >>> .ql-toolbar.ql-snow {
        display: block !important;
    }

    .questAnswer >>> .quill-editor .ql-container .ql-editor {
        padding: 8px;
        line-height: 22px;
        min-height: 150px;
    }

    .questionIndex {
        float: left;
        line-height: 32px;
    }

    .connect-error-dialog .el-button {
        margin-top: 10px;
        margin-bottom: 10px;
    }

    .connect-error-dialog i {
        color: #e6a23c;
        margin-right: 5px;
    }

    .connect-error-dialog p {
        text-align: center;
        line-height: 24px;
    }

    .container {
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;
    }
    .el-result {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        text-align: center;
        box-sizing: border-box;
        padding: 40px 30px;
    }

    .el-result__icon {
        font-weight: 400;
        -webkit-font-smoothing: antialiased;
        -webkit-tap-highlight-color: transparent;
        text-align: center;
    }

    .el-result__title {
        margin-top: 20px;
    }

    .el-result__subtitle {
        margin-top: 10px;
    }

    .el-result .icon-error {
        fill: #f56c6c;
    }

    .el-result__icon svg {
        width: 64px;
        height: 64px;
    }
</style>
<style>
    .handPaper .el-button:first-child {
        color: #fff;
        background-color: #67C23A;
        border-color: #67C23A;
    }

    .exam .infoCon p {
        line-height: 30px;
        text-indent: -24px;
        padding-left: 24px;
    }
</style>
